<div
    *ngIf="visible"
    class="lifecycle-banner w-full px-4 py-3 text-sm font-medium"
    [ngClass]="severityClass"
    role="status">
    <span [innerHTML]="messageHtml"></span>
</div>
